/**
 * FreeFieldDrawingPanel - Instructions and controls for free-field segment drawing
 *
 * Shows drawing button or instructions panel when drawing is active.
 */

import React from 'react';

interface FreeFieldDrawingPanelProps {
  isDrawing: boolean;
  onStartDrawing: () => void;
  onCancelDrawing: () => void;
}

export function FreeFieldDrawingPanel({
  isDrawing,
  onStartDrawing,
  onCancelDrawing,
}: FreeFieldDrawingPanelProps) {
  if (!isDrawing) {
    return (
      <button
        onClick={onStartDrawing}
        className="w-full py-2 px-4 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 transition-colors text-sm font-semibold"
      >
        + Draw Free-Field Segment
      </button>
    );
  }

  return (
    <div className="space-y-2">
      <div className="text-xs text-gray-600 bg-cyan-100 border border-cyan-300 rounded p-2">
        <p className="font-semibold mb-1">Drawing Free-Field Segment:</p>
        <p>• Click to add vertices</p>
        <p>• Double-click or Enter to finish</p>
        <p>• ESC to cancel</p>
      </div>
      <button
        onClick={onCancelDrawing}
        className="w-full py-2 px-4 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors text-sm"
      >
        Cancel Drawing
      </button>
    </div>
  );
}

export default FreeFieldDrawingPanel;
